<app-registered-practices></app-registered-practices>
<!--<router-outlet></router-outlet>-->
